module.exports = __webpack_public_path__ + "img/PU.f645015c.jpg";